// Store locator with customisations
// - custom marker
// - custom info window (using Info Bubble)
// - custom info window content (+ store hours)
// https://cdn.shopify.com/s/files/1/0250/6781/4964/files/Untitled-3-Recovered.png?11088
// var ICON = new google.maps.MarkerImage('https://cdn.shopify.com/s/files/1/0250/6781/4964/files/Untitled-3-Recovered.png?11088', null, null,
//     new google.maps.Point(14, 13));

document.addEventListener('DOMContentLoaded', (event) => {
    const marker_image = '//cdn.shopify.com/s/files/1/1802/9059/files/map-marker.png?v=1633348299';

    var ICON = new google.maps.MarkerImage(marker_image, null, null, new google.maps.Point(30, 20));

    google.maps.event.addDomListener(window, 'load', function () {
        var map = new google.maps.Map(document.getElementById('map-canvas'), {
            center: new google.maps.LatLng(51.5740707, -115.659956),
            zoom: 5,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#e9e9e9',
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5',
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 29,
                        },
                        {
                            weight: 0.2,
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 18,
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5',
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#dedede',
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            saturation: 36,
                        },
                        {
                            color: '#333333',
                        },
                        {
                            lightness: 40,
                        },
                    ],
                },
                {
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f2f2f2',
                        },
                        {
                            lightness: 19,
                        },
                    ],
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#fefefe',
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#fefefe',
                        },
                        {
                            lightness: 17,
                        },
                        {
                            weight: 1.2,
                        },
                    ],
                },
            ],
        });

        var panelDiv = document.getElementById('panel');

        var data = new MedicareDataSource();

        var view = new storeLocator.View(map, data, {
            geolocation: true,
        });

        view.createMarker = function (store) {
            var markerOptions = {
                position: store.getLocation(),
                icon: ICON,
                title: store.getDetails().title,
            };
            return new google.maps.Marker(markerOptions);
        };

        var infoBubble = new InfoBubble();
        view.getInfoWindow = function (store) {
            if (!store) {
                return infoBubble;
            }

            var details = store.getDetails();

            var html = [
                '<div class="store"><div class="title">',
                details.title,
                '</div><div class="address">',
                details.address,
                '</div>',
                '<div class="phone">',
                details.phone,
                '</div>',
                '<div class="fax">',
                details.fax,
                '</div>',
                '<div class="email">',
                details.email,
                '</div>',
                '<div class="page">',
                details.page,
                '</div>',
                '</div>',
            ].join('');

            infoBubble.setContent($(html)[0]);
            return infoBubble;
        };

        new storeLocator.Panel(panelDiv, {
            view: view,
        });
    });
});
